import BaseScene from './BaseScene'
import PlayerMoveToWithSpeed from '../../Animations/Movements/PlayerMoveToWithSpeed'
import { ScorerSpeed, WalkSpeed, BrownianSpeed } from './Constants'
import {randomInteger, calculateDistance, delay} from '../helper'

export default class Goal extends BaseScene {
    constructor(event, pitch) {
        super(pitch);

        this.Team = event.team;
        this.Player = event.player;
        this.Assist = event.assist;
        this.ShowReplay = window.PitchSettings.ShowGoalReplays;

        let keyPoints = pitch.getKeyPoints(this.Team == 1);
        this.CelebrationPoint = keyPoints.celebrationPoint;
        this.IsFinished = false;
    }

    Play(gameSpeed) {
        return new Promise(function(resolve, reject) {
            //this.SoundManager.playGoal(this.Team == 1);
            
            let scorer = this.GetPlayer(this.Team, this.Player);
            let assist = this.GetPlayer(this.Team, this.Assist);

            this.HighLightPlayers([scorer, assist]);

            //игроки пропустившей команды: сначала пребывают в ступоре на своих местах рендомное время, а затем плетутся на новые позиции
            this.getPlayersByTeam(this.Team == 1 ? 2 : 1, (p) => p.props.index < 11).forEach((player)=> {
                    player.BrownianMovement(gameSpeed, randomInteger(80, 140))
                    .then(()=> this.IsFinished != true ? player.WalkToNextPosition(gameSpeed, WalkSpeed) : null);
            });

            //автор гола бежит к трибунам праздновать, там проводит рендомное время, затем идет на новую позицию
            let scorerMovements = scorer.MoveToWithSpeed(gameSpeed, ScorerSpeed, this.CelebrationPoint)
                                        .then(() => scorer.BrownianMovement(gameSpeed, randomInteger(70, 120)))
                                        .then(() => this.ShowReplay == false ? 
                                            scorer.WalkToNextPosition(gameSpeed, WalkSpeed*2, false).then(()=> {this.IsFinished = true;resolve()}) 
                                            : 
                                            Promise.race([scorer.WalkToNextPosition(gameSpeed, WalkSpeed*2, false), delay(gameSpeed*75)]).then(()=> {this.IsFinished = true;resolve()}));

            //те кто были в пределах определенного расстояния до автора гола, бегут его поздравить, а потом идут на свои позиции
            let whoWantsToCelebrate = this.getPlayersByTeam(this.Team, (player) => {
                return player.Id != scorer.Id && calculateDistance(player.CurrentPosition, scorer.CurrentPosition) < 200;
            });

            whoWantsToCelebrate.forEach((player)=> {
                     player.BrownianMovement(gameSpeed, BrownianSpeed, randomInteger(5, 10)) //задержка
                    .then(() => this.IsFinished != true ? player.OvertakeOtherPlayer(scorer, gameSpeed, ScorerSpeed): null)
                    .then(() => this.IsFinished != true ? player.BrownianMovement(gameSpeed, randomInteger(30, 50)): null)
                    .then(() => this.IsFinished != true ? player.WalkToNextPosition(gameSpeed, WalkSpeed*2): null)
            })

            //остальные идут на свои позиции
            this.getPlayersByTeam(this.Team, (player)=> !this.PlayerIn(player, [...whoWantsToCelebrate, scorer]))
                .forEach((player)=> {
                    player.BrownianMovement(gameSpeed, randomInteger(100, 200))
                        .then(()=> this.IsFinished != true ? player.WalkToNextPosition(gameSpeed, WalkSpeed): null);
                });

        }.bind(this));
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Scenes/Goal.js
 **/